import { useEffect } from 'react';

import useIsInitialRender from './useIsInitialRender';

function useDispatchPeriodFiltersChange(filters) {
  const isInitialRender = useIsInitialRender();

  const { period, period_from_date, period_to_date } = filters;

  useEffect(() => {
    if (!isInitialRender) {
      document.dispatchEvent(
        new CustomEvent('period-filters-change', {
          detail: { period, period_from_date, period_to_date },
        })
      );
    }
  }, [period, period_from_date, period_to_date]);
}

export default useDispatchPeriodFiltersChange;
